import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {BaseResponse} from "../../../../api/api";
import { IResponseCollection } from '../../types/responseConstantsType';
import {IConstantCollection} from "../../types/constantsTypes";
import {snackbarAction} from "../../../errors/SnackbarSlice";

export const fetchConstInterestAddiction = createAsyncThunk<
    IConstantCollection[],
    void,
    ThunkConfig<string>
    >(
        'constants/fetchConstInterestAddiction',
        async (_, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;

            try {
                const response = await extra.api.get<BaseResponse<IResponseCollection>>(
                    `constants/interest-addiction`);
                if (!response.data.success || response.data.response.collection === null || response.data.codeKey !== 'SUCCESS') {
                    return rejectWithValue(response.data.codeKey)
                }

                return response.data.response.collection
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                console.log('err', err)
                // @ts-ignore
                return rejectWithValue(err.data.error);
            }
        },
    );
